import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { authCodeFlowConfig } from '../auth.config';


import { CORSService } from '../../api/service/cORS.service';
import { DocumentService } from '../../api/service/document.service';
import { DocumentMetadataService } from '../../api/service/documentMetadata.service';
import { MetadataDefinitionService } from '../../api/service/metadataDefinition.service';
import { AwsService } from '../../api/service/aws.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
		

	constructor(private oauthService: OAuthService, 
		private corsService: CORSService,
		private documentMetadataService: DocumentMetadataService,
		private documentService: DocumentService,
		private metadataDefinitionService: MetadataDefinitionService,
		private awsService: AwsService,		
		private router: Router) {

		// this.oauthService.configure(authCodeFlowConfig);
		// this.oauthService.loadDiscoveryDocumentAndLogin().
		// then(() => {
		// 	console.log('LoginComponent loadDiscoveryDocumentAndLogin completed', this.oauthService.hasValidAccessToken)}).
		// catch(err => 
		// 	console.error('LoginComponent loadDiscoveryDocumentAndLogin failed',err)).
		// 		finally(() => {
		// 			console.log('LoginComponent loadDiscoveryDocumentAndLogin finally')});
		// this.oauthService.initLoginFlow()
		// this.oauthService.setupAutomaticSilentRefresh();

		// Automatically load user profile
		// this.oauthService.events.pipe()		
		// 	.subscribe(event => {
		// 		if (event instanceof OAuthErrorEvent) {
		// 		  console.info(`Login event ${JSON.stringify(event)}`);
		// 		} else {
		// 		  console.info(`Login event ${JSON.stringify(event)}`);
		// 		}
		// 	  });
		// this.oauthService.events
		// 	.pipe(filter((e) => e.type === 'token_received'))
		// 	.subscribe((event) => {			
		// 		console.info(`LoginComponent ${JSON.stringify(event)}`);	
		// 		this.oauthService.loadUserProfile();
				
		// 		this.documentService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		// 		this.documentMetadataService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		// 		this.metadataDefinitionService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		// 		this.corsService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		// 		this.awsService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		// 		console.info(`LoginComponent before navigate to dashboard}`);					
		// 		this.router.navigate(['/dashboard']);
		// 		console.info(`LoginComponent after navigate to dashboard}`);	
		// 	});
	}

	ngOnInit() {
		// this.oauthService.loadDiscoveryDocumentAndLogin().then(() => {
		// 	console.log('LoginComponent ngOnInit completed', this.oauthService.hasValidAccessToken);
		// Login finished; navigate to home
			// window.location.href = '/dashboard';
			// this.router.navigate(['/dashboard']);
		// })
		console.log('LoginComponent ngOnInit completed');
  }
}
